import React from 'react';
import { CustomButton, Modifiers } from '@fw-nextgen/fw-components';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import ROUTES from '@app/src/common/constants/routeUrls';

interface IProps {
  email: string;
}

const ForgotPasswordConfirmation = ({ email }: IProps) => {
  const history = useHistory();
  const onClick = () => history.push(ROUTES.authPage.path);
  return (
    <>
      <h5 className="auth-window__heading">
        <FormattedMessage id="forgot.pass.confirm.heading" />
      </h5>
      <p className="auth-window__info">
        <FormattedMessage id="forgot.pass.confirm.description" />
      </p>
      <p className="auth-window__email">{email}</p>
      <CustomButton
        modifiers={[Modifiers.SMALL]}
        className="auth-window__button auth-window__button_with-margin-bottom"
        value="forgot.pass.confirm.login.link.label"
        onClick={onClick}
      />
    </>
  );
};

export default ForgotPasswordConfirmation;
